export class SideNav {
  checkAccountHideTransaction: boolean;
  fieldGroupType: string;
  accountTypeId: number;
  role: string;
}
